import { render, staticRenderFns } from "./RulesAndConditions.vue?vue&type=template&id=5e001a68&"
import script from "./RulesAndConditions.vue?vue&type=script&lang=js&"
export * from "./RulesAndConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports